import LibraryManager from "@/utils/libraries";

// load libraries
const loadLibraries = async () => (await import(/* webpackChunkName: "libraries" */ "../libraries.json")).libraries;

export default async function() {
    // load libraries
    const LIBRARIES = await loadLibraries();

    // create library manager
    const libraryManager = new LibraryManager();

    // register libraries
    for (const library of LIBRARIES) {
        // add library
        libraryManager.add(library);

        // force even for empty ones to load not structured UMD libraries for example
        const preload = library.preload || [];
        if (preload) {
            await libraryManager.needs(library.id, preload);
        }
    }
}
